import situation from '@/locales/en/tests/situation';
import problems from '@/locales/en/tests/problems';
import resources from '@/locales/en/tests/resources';

export default {
  home: {
    title: 'Put yourself to the test',
  },
  result: {
    title: 'Your Results',
    nextTests: 'Take the next test:',
  },
  situation: {
    title: 'First Aid Test',
    ...situation,
  },
  problems: {
    title: 'Solutions Finder Test',
    ...problems,
  },
  resources: {
    title: 'Strengths Finder Test',
    ...resources,
  },
  ressources: {
    title: 'Strengths Finder Test',
    ...resources,
  },
  email: {
    title: 'Have your results emailed to you',
    label: 'Your email address',
    validators: {
      required: 'An email address is required',
      valid: 'Invalid email address',
    },
    notification: {
      sending: 'Your results are on their...',
      sent: 'Email succesfully sent 🎉',
    },
    template: {
      subject: {
        situation: 'First Aid | profemina',
        problems: 'Your Decision | profemina',
        resources: 'Your Strengths | profemina',
        ressources: 'Your Strengths | profemina',
      },
      cta: '',
      greeting: 'Hello,',
      message: 'We are glad to be of service to you and hope that you have found this evaluation helpful. This is where you can retrieve your results for your perusal.',
      signatureGreeting: 'We wish you all the best for the path that lies before you!<br>Take care!',
      signature: 'Your <i>profemina</i> Counseling Team',
      ps: 'PS: We would love to continue to be there for you! Feel free to make use of our other tests: First Aid Test, Strengths Finder Test, Personality Test, Solutions Finder Test, Abortion Test',
      contact: 'PROFEMINA COUNSELING<br><br>Information, Counseling & Support for Pregnant Women: <a href="https://www.profemina.org/en/">www.profemina.org</a>',
      footer: 'This digital coaching service is provided by:<br>Profemina International Impresa Sociale S.r.l. • Via dei Portici 76 • 39100 Bolzano • Italy<br>Registered at the Commercial Registry, Bolzano • Registration, tax and VAT number: 03117840219<br>Authorized representative: Kristijan Aufiero, Chief Executive Officer • <a href="https://www.profemina.org/en/legal-notice">Legal Notice</a><br><br>OUR COUNSELING SERVICES:<br><i>profemina</i> is an international, independent, highly qualified, non-profit counseling service for women facing unintended pregnancies. We facilitate self-determined and independent decisions by providing pregnant women with judgement-free resources, such as objective information, excellent and increasingly diverse life coaching, as well as practical support.<br>Having counseled over 100,000 women, we have learned that external pressure from circumstances and people is the leading cause for abortion decisions.<br>Our goal at <i>profemina</i> is to stand with pregnant women in need, devising workable alternatives to abortion with all women who so desire, and  thereby making a FREE decision possible.<br>Our work is financed solely by private donors, who desire to support women experiencing unintended pregnancies. We are therefore able to offer our services completely free of charge to any woman seeking advice and support.<br><br>This is where you will find <a href="https://www.profemina.org/en/about-us/what-we-do">more information</a> about the principles underlying our work.<br><br>DATA PROTECTION:<br>All of your data and information will be treated strictly confidentially and is subject to full protection under the GDPR (General Data Protection Regulation) and will not be transferred to unauthorized persons! All important information about data processing, especially in relation to the General Data Protection Regulation (GDPR) is provided <a href="https://www.profemina.org/en/data-protection-policy">here</a>.<br><br>CONFIDENTIALITY:<br>This email and (if available) its attachments are intended for exclusive use by the recipient(s). This email and (if available) its attachments may include information which, by law, may be considered confidential and not subject to disclosure obligations.<br>If you are not the intended recipient of this email, you may not disclose, reproduce, forward, distribute or otherwise exploit its contents. Sending this email to persons other than the intended recipient does not represent a waiver of rights or preferential rights. If you received this email accidentally, please notify the sender by replying to and then immediately deleting this email from your system.',
    },
  },
  rating: {
    title: 'We appreciate your feedback 🤗',
    question1: '<strong>How impactful was this test in your decision making process?</strong>',
    question2: '<strong>Did you enjoy taking the test?</strong>',
    question3: '<strong>Would you use this app again?</strong>',
    textarea: {
      question: '<strong>What could we improve?</strong>',
      label: 'Your comment (optional)',
    },
    processing: 'Your feedback is being processed...',
    thanks: 'Thank you for your feedback 🤗',
  },
  welcome: 'Welcome to <i>profemina</i>’s Test App',
  language_switcher: {
    de: 'German',
    en: 'English',
    pt: 'Portuguese',
    it: 'Italian',
  },
  bottom_bar: {
    next: 'Continue',
    advice: 'Test Results',
  },
  refreshApp: {
    title: '<i>profemina</i> has made improvements 🎉',
    description: 'Please click "UPDATE" to get the latest available version.',
    button: 'Update',
  },
  loading: 'We are gathering the results of your personal online consultation…',
  notFound: {
    title: '404 - Page Not Found',
    subtitle: 'Oh no! This is unfortunate...',
    text: 'There seems to be something wrong with this page.',
  },
  connectivity: {
    offline: 'Oops! You’re offline...',
    online: 'Great to have you back online 🤗',
  },
};
